let BaseUrl = {};
switch (process.env.NODE_ENV) {
  case "development":
    BaseUrl = {
      dev: "https://cadd-mantra-online-course-api.techbrj.com",
      // dev: "https://e898-103-173-221-254.ngrok-free.app",
      // dev: "http://192.168.2.161:8000",
    };
    break;
  case "production":
    BaseUrl = {
      dev: "https://cadd-mantra-online-course-api.techbrj.com",
    };
    break;
  default:
    BaseUrl = {
      dev: "https://cadd-mantra-online-course-api.techbrj.com",
    };
    break;
}

export default BaseUrl;
